import { H2RInput } from "../imports";

export default function CropOptions({ cue, onUpdate }) {
	return (
		<>
			<div className="mx-20">
				<H2RInput
					placeholder="0"
					value={cue.crop?.top || 0}
					label="Crop Top %"
					type="number"
					min="0"
					max="100"
					onChange={(change) => {
						onUpdate({ crop: { ...cue.crop, top: change } });
					}}
				/>
			</div>
			<div className="flex space-x-10">
				<H2RInput
					placeholder="0"
					value={cue.crop?.left || 0}
					label="Crop Left %"
					type="number"
					min="0"
					max="100"
					onChange={(change) => {
						onUpdate({ crop: { ...cue.crop, left: change } });
					}}
				/>
				<H2RInput
					placeholder="0"
					value={cue.crop?.right || 0}
					label="Crop Right %"
					type="number"
					min="0"
					max="100"
					onChange={(change) => {
						onUpdate({ crop: { ...cue.crop, right: change } });
					}}
				/>
			</div>
			<div className="mx-20 pb-6">
				<H2RInput
					placeholder="0"
					value={cue.crop?.bottom || 0}
					label="Crop Bottom %"
					type="number"
					min="0"
					max="100"
					onChange={(change) => {
						onUpdate({ crop: { ...cue.crop, bottom: change } });
					}}
				/>
			</div>
		</>
	);
}
